import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LoggingService } from '../../services/logging.service';
import { LocalCacheManager } from '../managers/local-cache.manager';

import { Color } from '../models/color.model';
import { ApiUrlService } from './api-url.service';
import { ApiService } from './api.service';

@Injectable()
export class ColorsApiService extends ApiService
{
    constructor(protected http: HttpClient, protected apiUrlService: ApiUrlService, protected localCacheManager: LocalCacheManager)
    {
        super(http, localCacheManager);
    }

    getColors(accountId: number,type:number): Observable<Color[]>
    {
        return this.apiRequest(this.apiUrlService.getGetColorsUrl(accountId,type), this.HttpMethod.Get);
    }


    addColor(accountId: number, createColorModel: Color): Observable<any>
    {
        return this.apiRequest(this.apiUrlService.getAddColorUrl(accountId), this.HttpMethod.Post, createColorModel);
    }

    deleteColor(id:number,type:number):Observable<any>{
        return this.apiRequest(this.apiUrlService.getDeleteColorUrl(id,type),this.HttpMethod.Delete);
    }
    // exportColorPalette(): File
    // {
    //     return null;
    // }

    // importColorPalette(File ): Observable<any>
    // {
    // }
}
